/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { getDialogInitData } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { DialogInput } from '@gh/core-ui';

import { isEmpty } from 'lodash';

import { UsageDialogConfig } from '../resources/usage-dialog-business.service';
import { UsageListItem, UsageModel } from '../resources/usage-dialog.model';
import { UsageDialogGridDefinition } from './usage-dialog-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-usage-dialog',
  templateUrl: './usage-dialog.component.html',
  styleUrls: ['./usage-dialog.component.scss'],
  providers: [UsageDialogGridDefinition],
})
export class UsageDialogComponent implements OnInit, DialogInput<UsageDialogConfig> {

  input: UsageDialogConfig;
  usageData: UsageModel;
  items: UsageListItem[];

  constructor(public gridDefinition: UsageDialogGridDefinition,
              private translations: TranslationService,
              @Inject(MAT_DIALOG_DATA) private dialogData: any) {
  }

  get title(): string {
    return `lbl_view_usage:${this.input.entityType}`;
  }

  ngOnInit(): void {
    const { usageData } = getDialogInitData(this.dialogData);
    this.usageData = usageData;
    this.items = isEmpty(usageData.usage) ? [{
      entityType: this.translations.get('lbl_hp_not_use'),
      entityName: '',
    }] : usageData.usage;
  }
}
